import rand from "@/utils/rand";
import {AwsService} from "@/simulation/AwsService";
import {Lambda} from "@/simulation/Lambda";

export class EventBridge implements AwsService {
    id = rand();
    name = 'EventBridge';
    targets: Array<Lambda> = [];
    receiveCount = 0;
    successes = 0;
    errors = 0;

    invoke(): void {
        this.receiveCount++;
        this.targets.map((lambda: Lambda) => {
            try {
                lambda.invokeAsync();
                this.successes++;
            } catch (e) {
                this.errors++;
            }
        });
    }

    connectToLambda(lambda: Lambda) {
        this.targets.push(lambda);
    }

    reset() {
        this.receiveCount = 0;
        this.successes = 0;
        this.errors = 0;
    }

    outputs(): Array<AwsService> {
        return this.targets;
    }
}
